import React from "react";

function ChartLegendItem(props) {
  const {
    label,
    name,
    color
  } = props

  return (
    <li className={ 'legend-item legend-item--' + color } >
      { name }
      <div className='legend-item__amount grey'>{ label }</div>
    </li>
  )
}

export default ChartLegendItem
